export const CHECKOUT_URL = 'https://nursing-instructor-atlas.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/59690b7b-2a50-41a6-b17e-76616d8863bb/product-uploads/mcp_66dcd0aa-eda0-4727-93e5-ccf1be2d73bc_1793760794821.png'

export const HERO_IMAGE_ALT =
  'Nursing Instructor Atlas 6-in-1 box set in navy, teal and white: 6 visual nursing education and clinical training volumes for nursing instructors, clinical faculty and nurse educators'

export const VISUAL_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/59690b7b-2a50-41a6-b17e-76616d8863bb/product-uploads/mcp_b6b5357f-fe02-416a-9e7f-e92d05616320_1793760813433.jpg'

export const VISUAL_IMAGE_ALT =
  'Nursing Instructor Atlas: the 6-volume box set next to a tablet with the nursing teaching areas, 100% visual material for nursing instructors, from beginner to advanced, with immediate access'

export const PRIMARY_CTA = 'GET NURSING INSTRUCTOR ATLAS NOW!'

export const PRICE_LABEL = '$27 USD'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus' | 'extra'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 01 — Nursing Fundamentals, Patient Care & Essential Clinical Skills' },
  { kind: 'included', label: 'Volume 02 — Human Anatomy, Health Assessment & Clinical Examination' },
  { kind: 'included', label: 'Volume 03 — Nursing Procedures, Clinical Interventions & Patient Safety' },
  { kind: 'included', label: 'Volume 04 — Nursing Pharmacology, Medication Administration & Dosage Calculations' },
  { kind: 'included', label: 'Volume 05 — Medical-Surgical Nursing, Emergency Care & Clinical Decision-Making' },
  { kind: 'included', label: 'Volume 06 — Nursing Instruction, Clinical Simulation & Competency Assessments' },
  { kind: 'bonus', label: 'Nursing Skills & Vital Signs Flashcards' },
  { kind: 'bonus', label: 'Clinical Skills Demonstration Lesson Scripts' },
  { kind: 'bonus', label: 'Skills Lab & Simulation Drills' },
  { kind: 'bonus', label: 'Dosage Calculation Practice Workbook' },
  { kind: 'bonus', label: 'Nursing Competency Checklists, Rubrics & Certificates' },
  { kind: 'extra', label: '100% Visual Training System' },
  { kind: 'extra', label: 'Immediate Digital Access' },
  { kind: 'extra', label: 'One-Time Payment' },
]
